export const ServiceErrorCodes = {
    // myr
    CHALLENGE_NOT_PASSED: 'myr-6016' /* Challenge was not passed */,
    MEMBER_NOT_LINKED_ERROR: 'myr-6023' /* Forbidden At RID - Member Not linked */,
    EMAIL_VERIFY_CONFLICT: 'myr-6028',
    EMAIL_VERIFY_CONFLICT_JP: 'rid-1004',

    // oauth api
    TOKEN_EXPIRED_ON_READ_WRITE_ACCESS: 'oauth-7037' /* Token expired on read or write */,
    TOKEN_REVOCATION_FAILURE: 'oauth-7039' /* Token revocation failed */,
};
